(function() {
  var __sections__ = {};
  (function() {
    for(var i = 0, s = document.getElementById('sections-script').getAttribute('data-sections').split(','); i < s.length; i++)
      __sections__[s[i]] = true;
    })();
    (function() {
  if (!__sections__["media"] && !Shopify.designMode) return;
  try {
    
  (function () {
    if (customElements.get('media-video')) return;
    customElements.define(
      'media-video',
      class extends HTMLElement {
        constructor() {
          super();
          this.video = null;
          this.reduceMotionQuery = null;
          this.handleReduceMotionChange = this.handleReduceMotionChange.bind(this);
        }

        connectedCallback() {
          this.teardown();
          this.video = this.querySelector('video');
          if (!this.video) return;

          this.reduceMotionQuery = window.matchMedia('(prefers-reduced-motion: reduce)');
          if (typeof this.reduceMotionQuery.addEventListener === 'function') {
            this.reduceMotionQuery.addEventListener('change', this.handleReduceMotionChange);
          } else if (typeof this.reduceMotionQuery.addListener === 'function') {
            this.reduceMotionQuery.addListener(this.handleReduceMotionChange);
          }
          this.syncPlayback();
        }

        disconnectedCallback() {
          this.teardown();
        }

        handleReduceMotionChange() {
          this.syncPlayback();
        }

        prefersReducedMotion() {
          if (this.reduceMotionQuery) return Boolean(this.reduceMotionQuery.matches);
          return window.matchMedia('(prefers-reduced-motion: reduce)').matches;
        }

        syncPlayback() {
          if (!this.video) return;
          if (this.prefersReducedMotion()) {
            this.video.pause();
            return;
          }
          const playResult = this.video.play();
          if (playResult && typeof playResult.catch === 'function') {
            playResult.catch(() => {});
          }
        }

        teardown() {
          if (this.reduceMotionQuery) {
            if (typeof this.reduceMotionQuery.removeEventListener === 'function') {
              this.reduceMotionQuery.removeEventListener('change', this.handleReduceMotionChange);
            } else if (typeof this.reduceMotionQuery.removeListener === 'function') {
              this.reduceMotionQuery.removeListener(this.handleReduceMotionChange);
            }
            this.reduceMotionQuery = null;
          }
        }
      }
    );
  })();

  } catch(e) { console.error(e); }
})();
})();
